import React from 'react';

import { SocialCta, Icon } from '@bumble/ui-kit';
import common from 'components/lexemes/common';
import lexemes from 'components/lexemes/page-about';

export const AboutWorkWithUsContainer: React.FC = () => {
  const socialLinks = [
    {
      url: 'https://www.instagram.com/bumble',
      a11yLabel: common.lxA11ySocialLink('Instagram'),
      iconName: Icon.Name.Instagram,
    },
    {
      url: 'https://www.facebook.com/bumbleapp',
      a11yLabel: common.lxA11ySocialLink('Facebook'),
      iconName: Icon.Name.Facebook,
    },
    {
      url: 'https://www.twitter.com/bumble',
      a11yLabel: common.lxA11ySocialLink('Twitter'),
      iconName: Icon.Name.Twitter,
    },
    {
      url: 'https://www.linkedin.com/company/bumbleinc/',
      a11yLabel: common.lxA11ySocialLink('Linkedin'),
      iconName: Icon.Name.Linkedin,
    },
    {
      url: 'https://www.pinterest.com/bumbleapp',
      a11yLabel: common.lxA11ySocialLink('Pinterest'),
      iconName: Icon.Name.Pinterest,
    },
    {
      url: 'https://www.youtube.com/bumble',
      a11yLabel: common.lxA11ySocialLink('Youtube'),
      iconName: Icon.Name.Youtube,
    },
    {
      url: 'https://www.tiktok.com/@bumble',
      a11yLabel: common.lxA11ySocialLink('Tiktok'),
      iconName: Icon.Name.Tiktok,
    },
  ];

  return (
    <SocialCta
      title={lexemes.lxPageAboutWorkWithUsTitle}
      description={lexemes.lxPageAboutWorkWithUsDescription}
      cta={{
        text: lexemes.lxPageAboutWorkWithUsCta,
        href: 'https://jobs.ashbyhq.com/bumbleinc',
      }}
      socialLinks={socialLinks}
    />
  );
};
